export const SETLOCLIST = "SETLOCLIST";
export const SETCOSTCENTRLIST = "SETCOSTCENTRLIST";
export const SETPRJOLIST = "SETPRJOLIST";
export const SETSELECTCATEGORY = "SETSELECTCATEGORY";
export const SETSELECTTAX = "SETSELECTTAX";
export const SETEXPITEMLIST = "SETEXPITEMLIST";
export const EXPCLIAMCLEARDOC = "EXPCLIAMCLEARDOC";
export const EXPCLMLIST = "EXPCLMLIST";
export const EXPCLMCUSTOMERLIST = "EXPCLMCUSTOMERLIST";
export const EXPCLMDOCNUMLIST = "EXPCLMDOCNUMLIST";
export const EXPCLMEXPORTFILE = "EXPCLMEXPORTFILE";
export const EXPCLMDUPLICATE = "EXPCLMDUPLICATE";
export const SETEXPADVANCEFILTERLIST = "SETEXPADVANCEFILTERLIST";
export const SETEXPCLMATTACHMENTLIST = "SETEXPCLMATTACHMENTLIST";
export const SETEXPCLMATTACHMENTLISTROW = "SETEXPCLMATTACHMENTLISTROW";
export const SETPOSERIESLIST = "SETPOSERIESLIST";
export const SETEXPCLAIMDOC = "SETEXPCLAIMDOC";
export const SETEXPDEFCLAIMDOC = "SETEXPDEFCLAIMDOC";
export const SETEXPENSECLAIMBASICFILTERDATA = "SETEXPENSECLAIMBASICFILTERDATA";
export const SETUSEREXPENSEPOLICY = "SETUSEREXPENSEPOLICY";
export const SETEXPENSEPERDIEM = "SETEXPENSEPERDIEM";
export const SETEXPENSEMILEAGE = "SETEXPENSEMILEAGE";
